const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine=matchMedia('(hover:hover)').matches;
requestAnimationFrame(()=>document.body.classList.add('ready'));

/* hide images that fail to load so cards fall back to their designed background */
$$('img').forEach(i=>{if(!i.hasAttribute('onerror'))i.addEventListener('error',()=>i.style.visibility='hidden')});

/* nav + mobile menu */
const nav=$('#nav'),hero=$('#hero'),totop=$('#totop'),mm=$('#mmenu');
$('#burger').onclick=()=>{mm.classList.add('open');mm.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'};
$('#mclose').onclick=()=>{mm.classList.remove('open');mm.setAttribute('aria-hidden','true');document.body.style.overflow=''};

/* reveal */
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.14,rootMargin:'0px 0px -6% 0px'});
$$('.reveal').forEach(el=>io.observe(el));
const cio=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');cio.unobserve(e.target)}}),{threshold:.35});
cio.observe($('#chart'));

/* scroll: nav state, pinned rail, best-seller float */
const hs=$('#hscroll'),rail=$('#rail'),bs=$('#bsImg');
function onScroll(){
  const y=scrollY,overHero=hero.getBoundingClientRect().bottom>80;
  nav.classList.toggle('ondark',overHero);nav.classList.toggle('solid',!overHero);nav.classList.toggle('scrolled',y>20);
  totop.classList.toggle('show',y>900);
  if(innerWidth>860){
    const r=hs.getBoundingClientRect(),total=hs.offsetHeight-innerHeight,p=Math.min(Math.max(-r.top/total,0),1);
    rail.style.transform=`translate3d(${-p*Math.max(0,rail.scrollWidth-innerWidth+80)}px,0,0)`;
  }else rail.style.transform='';
  const br=bs.getBoundingClientRect();
  if(br.bottom>0&&br.top<innerHeight&&!reduce){const p=(br.top+br.height/2-innerHeight/2)/innerHeight;bs.style.transform=`translateY(${p*-50}px) rotate(${p*-6}deg)`}
}
addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);onScroll();

/* HERO: power spotlight */
(function(){
  const scene=$('#scene'),cur=$('#cursor'),curTxt=$('#curTxt'),sw=$('#switch');
  let tx=62,ty=46,cx=62,cy=46,mx=innerWidth/2,my=innerHeight/2,dx=mx,dy=my,inside=false,vis=false;
  new IntersectionObserver(([e])=>{const was=vis;vis=e.isIntersecting;if(vis&&!was)requestAnimationFrame(loop)}).observe(hero);
  hero.addEventListener('pointermove',e=>{const r=hero.getBoundingClientRect();tx=(e.clientX-r.left)/r.width*100;ty=(e.clientY-r.top)/r.height*100;mx=e.clientX;my=e.clientY;inside=true;if(fine)cur.classList.add('on')});
  hero.addEventListener('pointerleave',()=>{inside=false;cur.classList.remove('on')});
  hero.querySelectorAll('a,#switch').forEach(el=>{
    el.addEventListener('pointerenter',()=>{cur.classList.add('big');curTxt.textContent=el.id==='switch'?'Power':'Open'});
    el.addEventListener('pointerleave',()=>{cur.classList.remove('big');curTxt.textContent='Light'});
  });
  function loop(t){
    if(!vis)return;
    if(!inside){tx=62+Math.sin(t/1800)*18;ty=46+Math.cos(t/2300)*12}
    cx+=(tx-cx)*.09;cy+=(ty-cy)*.09;
    hero.style.setProperty('--mx',cx+'%');hero.style.setProperty('--my',cy+'%');
    if(!reduce)scene.style.transform=`translate3d(${(cx-50)*-.3}px,${(cy-50)*-.2}px,0)`;
    dx+=(mx-dx)*.22;dy+=(my-dy)*.22;cur.style.transform=`translate(${dx}px,${dy}px) translate(-50%,-50%)`;
    requestAnimationFrame(loop);
  }
  function toggle(){const on=hero.classList.toggle('powered');sw.classList.add('flipped');sw.setAttribute('aria-checked',on);
    $('#st').textContent=on?'Running':'Standby';$('#swLabel').textContent=on?'Powered on':'Flip the switch'}
  sw.addEventListener('click',toggle);
  sw.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();toggle()}});
})();

/* MODEL SHOWCASE */
(function(){
  const M=window.AC_MODELS||[];
  const sc=$('#showcase'),swr=$('#switcher'),img=$('#mImg');
  M.forEach((m,i)=>{const b=document.createElement('button');b.className='model';b.setAttribute('role','tab');
    b.innerHTML=`<img src="${m.img}${m.img.indexOf('?')>-1?'&':'?'}width=120" alt="" loading="lazy" width="46" height="46">${m.name}<span class="prog"></span>`;
    b.onclick=()=>{paused=true;swr.classList.add('paused');show(i)};swr.append(b)});
  let cur=-1,paused=false,timer,visible=false;
  function next(){clearTimeout(timer);if(!paused&&visible)timer=setTimeout(()=>show((cur+1)%M.length),6000)}
  function show(i,first){
    if(i===cur)return;const m=M[i],dir=i>cur;
    [...swr.children].forEach((b,j)=>{b.classList.toggle('on',j===i);b.setAttribute('aria-selected',j===i)});
    const sw=$$('#showcase .swap');sw.forEach(s=>s.classList.add('out'));
    if(!first)img.className=dir?'out':'pre';
    setTimeout(()=>{
      $('#mName').innerHTML=`<small>ActiveStart · ${m.sku}</small>${m.name}`;
      $('#mDesc').textContent=m.desc;
      $('#mPrice').innerHTML=`<b>${m.price}</b>${m.tag?`<span class="tag mono">${m.tag}</span>`:''}`;
      $('#mSku').textContent=m.sku;$('#mFor').textContent=m.for;$('#mIns').textContent=m.ins;$('#h1').textContent=m.ins;$('#mLink').href=m.url;{const c=document.getElementById('mCompare');if(c)c.href=m.cmp||c.dataset.def;}
      img.style.visibility='';img.src=m.img;img.alt='ActiveStart '+m.name+' soft start';img.className=dir?'pre':'out';
      requestAnimationFrame(()=>requestAnimationFrame(()=>img.className=''));
      sw.forEach(s=>s.classList.remove('out'));cur=i;next();
    },first?0:340);
  }
  show(2,true);
  const product=$('#product'),floor=$('#floor'),bw=$('#bw'),bwf=$('#bwf'),hots=$$('.hot');
  let tx=0,ty=0,cx=0,cy=0;
  new IntersectionObserver(([e])=>{const was=visible;visible=e.isIntersecting;if(visible){next();if(!was)loop()}else clearTimeout(timer)}).observe(sc);
  sc.addEventListener('pointermove',e=>{const r=sc.getBoundingClientRect();tx=(e.clientX-r.left)/r.width*2-1;ty=(e.clientY-r.top)/r.height*2-1;
    const b=bwf.getBoundingClientRect();bwf.style.setProperty('--lx',(e.clientX-b.left)+'px');bwf.style.setProperty('--ly',(e.clientY-b.top)+'px')});
  sc.addEventListener('pointerleave',()=>{tx=ty=0;bwf.style.setProperty('--lx','-999px')});
  function loop(){
    if(!visible||reduce)return;
    cx+=(tx-cx)*.08;cy+=(ty-cy)*.08;
    product.style.transform=`rotateY(${cx*20}deg) rotateX(${-cy*14}deg) translateZ(30px)`;
    product.style.setProperty('--gx',(50+cx*45)+'%');product.style.setProperty('--gy',(30+cy*45)+'%');
    floor.style.transform=`translateX(calc(-50% + ${cx*-30}px)) scaleX(${1-Math.abs(cx)*.15})`;
    hots.forEach(h=>h.style.translate=`${cx*h.dataset.d*22}px ${cy*h.dataset.d*16}px`);
    [bw,bwf].forEach(b=>b.style.transform=`translate(calc(-50% + ${cx*-60}px),calc(-50% + ${cy*-20}px))`);
    requestAnimationFrame(loop);
  }
})();

/* product tabs */
$('#tabs').addEventListener('click',e=>{
  const t=e.target.closest('.tab');if(!t)return;
  $$('.tab').forEach(x=>x.classList.toggle('on',x===t));
  const f=t.dataset.f;let n=0;
  $$('.pcard').forEach(p=>{const ok=f==='all'?n<8:p.dataset.c.split(' ').includes(f);if(ok)n++;p.classList.toggle('hide',!ok);p.style.opacity=1});
  document.dispatchEvent(new CustomEvent('products:filtered'));
});

/* FAQ: one open at a time */
$$('.faq details').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)$$('.faq details').forEach(o=>{if(o!==d)o.open=false})}));
